import { render } from "./ready-order-block.vue?vue&type=template&id=384f9aba&scoped=true"
import script from "./ready-order-block.vue?vue&type=script&lang=js"
export * from "./ready-order-block.vue?vue&type=script&lang=js"

import "./ready-order-block.vue?vue&type=style&index=0&id=384f9aba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384f9aba"]])

export default __exports__